<template>
  <div class="my-collection">
    <div class="section-title">我的收藏</div>

    <!-- 收藏列表 -->
    <div class="collection-list">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="商品收藏" name="product">
          <empty-component text="暂无收藏的商品哦~"></empty-component>
        </el-tab-pane>
        <el-tab-pane label="店铺收藏" name="shop">
          <empty-component text="暂无收藏的店铺哦~"></empty-component>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import EmptyComponent from './EmptyComponent.vue'

export default {
  name: 'MyCollection',
  components: {
    EmptyComponent
  },
  data() {
    return {
      activeTab: 'product'
    }
  }
}
</script>

<style lang="scss" scoped>
.my-collection {
  .section-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    text-align: left;
  }

  .collection-list {
    background-color: #fff;
    border-radius: 4px;
    padding: 20px;

    :deep(.el-tabs__nav-wrap::after) {
      height: 1px;
    }

    :deep(.el-tabs__active-bar) {
      height: 2px;
    }
  }
}
</style>
